import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { TableCell, TableRow, Tooltip, IconButton } from '@mui/material';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import DeleteIcon from '@mui/icons-material/Delete';
import { indexColumn } from '../../styles';
import useTranslation from '../../hooks/useTranslation';

const typeLabel = (t, type) => {
  const map = { low_stock: t('labels.low_stock') || 'Low stock' };
  return map[type] ?? String(type || '').replace(/_/g, ' ');
};

const NotificationRow = ({ id, title, body, type, status, index, onRead, onDelete, data }) => {
  const { t } = useTranslation();

  return (
    <TableRow key={id}>
      <TableCell component="th" scope="row" sx={indexColumn}>{index}</TableCell>
      <TableCell component="th" scope="row">
        {data?.product_id ? (
          <Link
            to={`/admin/products/edit/${data.product_id}`}
            style={{ textDecoration: 'none' }}
          >
            {title}
          </Link>
        ) : (
          title
        )}
      </TableCell>
      <TableCell component="th" scope="row">{body}</TableCell>
      <TableCell component="th" scope="row">{typeLabel(t, type)}</TableCell>
      <TableCell component="th" scope="row">{status}</TableCell>
      <TableCell align="left">
        {status !== 'read' && (
          <Tooltip title={t('labels.mark_read') || 'Mark read'}>
            <IconButton color="primary" size="small" onClick={() => onRead(id)}>
              <DoneAllIcon />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title={t('labels.delete') || 'Delete'}>
          <IconButton color="error" size="small" onClick={() => onDelete(id)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

NotificationRow.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onRead: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default NotificationRow;